
<div class="top-row">
    <app-widget-area></app-widget-area>
</div>

<br>
<mat-divider></mat-divider>
<br>

<div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px" class="stats-cards">
    <mat-card fxFlex="25">
        <app-widget-card label="Subjects" total={{subjects.length}}  ></app-widget-card>
    </mat-card>
    <mat-card fxFlex="25">
        <app-widget-card label="Classes" total={{classes.length}}  ></app-widget-card>
    </mat-card>
    <mat-card fxFlex="25">
        <app-widget-card label="Students" total={{students.length}} ></app-widget-card>
    </mat-card>
    <mat-card fxFlex="25">
        <app-widget-card label="Question Bank" total={{questions.length}} ></app-widget-card>
    </mat-card>
    <mat-card fxFlex="25">
        <app-widget-card label="Exams" total={{exams.length}}  ></app-widget-card>
    </mat-card>
</div>
<br>
<mat-divider></mat-divider>
<br>
